import * as React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Color from '../../../layouts/Color';

const cardData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const cardNoData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const paddingGrid = { padding: 2 };

export default function FrontCardData(props) {

    const renderFrontCardData = (data) => {
        return data ? (<Card sx={cardData}>
            <Grid container spacing={3} sx={paddingGrid}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> No: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.id} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Name:  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.name} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Gender: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.sex} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> DOB: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.dob} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Nationality: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.nationality} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Address: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.address} </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> DOE: </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {data.doe} </Typography>
                </Grid>
            </Grid>
        </Card>) : (
            <Card sx={cardNoData}>
              
            </Card>
        );
    }

    return (
        <React.Fragment>
            {renderFrontCardData(props.eKycFrontResponse)}
        </React.Fragment>
    );
}